import actionCreatorFactory from 'typescript-fsa'
import { Message } from '@professocial/professocialTypes/types/messageTypes'

import {
  CaptchaSolution,
  UserSettings,
} from '@professocialApi/professocial-core-frontend-api/models/index'
import {
  ChangePasswordByUserRequest,
  ConfirmUserAccountRequest,
  // LoginAsRequest,
  RegisterUserAccountRequest,
  RestPasswordForUserRequest,
  UserLoginRequest,
} from '@professocialApi/professocial-core-frontend-api/apis/AutorisationROApi'
import { GetNewCaptchaRequest } from '@professocialApi/professocial-core-frontend-api'

const actionCreator = actionCreatorFactory('LOGIN')

/*
 * Actions
 */
export const userLoginInitiated = actionCreator<UserLoginRequest>('USER_LOGIN_INITIATED')
export const userLogin = actionCreator.async<UserLoginRequest, UserSettings>('USER_LOGIN')

export const restPasswordForUserInitiated = actionCreator<RestPasswordForUserRequest>('RESET_PASSWORD_FOR_USER_INITIATED')
export const restPasswordForUser = actionCreator.async<RestPasswordForUserRequest, undefined >('RESET_PASSWORD_FOR_USER')

export const registerUserAccountInitiated = actionCreator<RegisterUserAccountRequest>('REGISTER_USER_ACCOUNT_INITIATED')
export const registerUserAccount = actionCreator.async<RegisterUserAccountRequest, UserSettings>('REGISTER_USER_ACCOUNT')

// Neue Actions für den Erfolg/Fehler der zweiten Registrierung
export const registerFailedUserAccountSuccess = actionCreator('REGISTER_FAILED_USER_ACCOUNT_SUCCESS')
export const registerFailedUserAccountError = actionCreator<any>('REGISTER_FAILED_USER_ACCOUNT_ERROR')

export const confirmUserAccountInitiated = actionCreator<ConfirmUserAccountRequest>('CONFIRM_USER_ACCOUNT_INITIATED')
export const confirmUserAccount = actionCreator.async<ConfirmUserAccountRequest, undefined>('CONFIRM_USER_ACCOUNT')

export const changePasswordByUserInitiated = actionCreator<ChangePasswordByUserRequest>('CHANGE_PASSWORD_BY_USER_INITIATED')
export const changePasswordByUser = actionCreator.async<ChangePasswordByUserRequest, undefined>('CHANGE_PASSWORD_BY_USER')

export const setUser = actionCreator<any>('SET_USER_LOGIN')
export const setMessage = actionCreator<Message>('SET_MESSAGE')

export const setRedirectPath = actionCreator<string | undefined>('SET_REDIRECT_PATH')

export const getNewCaptchaInitiated = actionCreator<GetNewCaptchaRequest>('GET_NEW_CAPTCHA_INITIATED')
export const getNewCaptcha = actionCreator.async<GetNewCaptchaRequest, CaptchaSolution>('GET_NEW_CAPTCHA')
